import {ChangeDetectorRef, Component, ElementRef, Renderer2} from '@angular/core';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';

import {BaseFieldComponent} from '../../base/base-field/base-field.component';


@Component({
    selector: 'app-signature-field',
    templateUrl: './signature-field.component.html',
    styleUrls: ['./signature-field.component.scss']
})
export class SignatureFieldComponent extends BaseFieldComponent<any> {
    public readonly staticCssClass = 'signature-image-field';
    options = {penColor: 'black'};
    public collapsed: boolean;


    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher, element, renderer);
    }

    public onClick() {
        if ((this.fieldWrapper.config).click) {
            (this.fieldWrapper.config).click();
        }

        this.eventDispatcher.notifyControlClick(this.fieldWrapper.config);
    }
    public onResize(event) {
        const collapsed = event.contentRect.width <= 500;
        if (collapsed !== this.collapsed) {
            this.collapsed = collapsed;
            this.changeDetectorRef.detectChanges();
        }
    }

}
